import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-gray-900 text-left w-full" }, " Importar configurações de excepcionalidade ", -1)
const _hoisted_2 = { class: "flex gap-4 w-full" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-gray-900 text-left w-full" }, " Importar configurações de excepcionalidade ", -1)
const _hoisted_6 = { class: "flex flex-col items-center gap-4 py-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-base text-textPrimary text-center" }, [
  /*#__PURE__*/_createTextVNode(" Configurações de excepcionalidade importadas"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" com sucesso para essa escala ")
], -1)

import { ref, computed, watch } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import Tabs from '@/components/designSystem/Tabs/Tabs.vue'
import type { TabItem } from '@/components/designSystem/Tabs/Tabs.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import ConfirmDeleteRoleModal from '@/components/ManageScale/Schedule/modals/ConfirmDeleteRoleModal.vue'
import SuccessIcon from '@/assets/icons/success.vue'
import ConfigTemplateTab from './components/ConfigTemplateTab.vue'
import UnitsAndScalesTab from './components/UnitsAndScalesTab.vue'
import { useApprovalFlowStore } from '@/pinia-store/useApprovalFlowStore'
import { useErrorToast } from '@/composables/useErrorToast'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportExceptionalityConfigModal',
  props: {
    modalActive: { type: Boolean },
    savedTemplate: {},
    scheduleId: {},
    companyId: {}
  },
  emits: ["close", "save"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;

const approvalFlowStore = useApprovalFlowStore()
const { notifyError } = useErrorToast()





const tabItems: TabItem[] = [
  { label: 'Modelos de Configuração', value: 'templates' },
  { label: 'Unidades e Escalas', value: 'scales' }
]

const configTemplateTabRef = ref<InstanceType<typeof ConfigTemplateTab> | null>(null)
const activeTab = ref('templates')
const selectedTemplateId = ref<number | null>(null)
const selectedScaleId = ref<number | null>(null)
const showDeleteConfirm = ref(false)
const templateToDeleteId = ref<number | null>(null)
const isDeletingTemplate = ref(false)
const showSuccessModal = ref(false)

const openDeleteConfirm = (id: number) => {
  templateToDeleteId.value = id
  showDeleteConfirm.value = true
}

const handleConfirmDelete = async () => {
  if (templateToDeleteId.value !== null && props.companyId) {
    isDeletingTemplate.value = true
    try {
      await approvalFlowStore.deleteTemplate(templateToDeleteId.value, props.companyId)
      configTemplateTabRef.value?.removeTemplate()
    } catch (error) {
      // A store NÃO exibe nada (só relança): antes a exclusão falhava em silêncio.
      notifyError(error, 'Não foi possível excluir o modelo de configuração.')
    } finally {
      isDeletingTemplate.value = false
    }
  }
  showDeleteConfirm.value = false
  templateToDeleteId.value = null
}

watch(
  () => props.modalActive,
  (active) => {
    if (active) {
      if (props.scheduleId) {
        // A action relança desde o M2: sem o catch, a falha virava unhandled
        // rejection e a aba aparecia vazia, como se não houvesse modelos.
        approvalFlowStore.fetchTemplatesBySchedule(props.scheduleId).catch((error) => {
          notifyError(error, 'Não foi possível carregar os modelos de configuração.')
        })
      }
      if (props.savedTemplate) {
        activeTab.value = 'templates'
        selectedTemplateId.value = props.savedTemplate.id
      }
    }
  }
)

watch(activeTab, (tab) => {
  if (tab === 'scales' && props.companyId) {
    approvalFlowStore.fetchGroupedTemplates(props.companyId).catch((error) => {
      notifyError(error, 'Não foi possível carregar as unidades e escalas com modelos.')
    })
  }
})

const hasSelection = computed(() => {
  return activeTab.value === 'templates'
    ? selectedTemplateId.value !== null
    : selectedScaleId.value !== null
})

const resetState = () => {
  activeTab.value = 'templates'
  selectedTemplateId.value = null
  selectedScaleId.value = null
}

const closeSuccessModal = () => {
  showSuccessModal.value = false
}

const handleClose = () => {
  resetState()
  emit('close')
}

const handleSave = () => {
  if (!hasSelection.value) return

  if (activeTab.value === 'templates' && selectedTemplateId.value !== null) {
    emit('save', { source: 'template', id: selectedTemplateId.value })
  } else if (activeTab.value === 'scales' && selectedScaleId.value !== null) {
    emit('save', { source: 'template', id: selectedScaleId.value })
  }

  resetState()
}

const onImportSuccess = () => {
  showSuccessModal.value = true
}

__expose({ onImportSuccess })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ModalVue, {
      "modal-active": _ctx.modalActive,
      "max-width": "!max-w-[1000px]",
      "has-footer-border": "",
      "has-header-border": "",
      onClose: handleClose
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(OutlineButton, {
              text: "Cancelar",
              width: "100%",
              onClick: handleClose
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(FilledButton, {
              text: "Importar",
              width: "100%",
              disabled: !hasSelection.value,
              onClick: handleSave,
              class: "bg-primary30"
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(Tabs, {
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event)),
          tabs: tabItems
        }, {
          templates: _withCtx(() => [
            _createVNode(ConfigTemplateTab, {
              ref_key: "configTemplateTabRef",
              ref: configTemplateTabRef,
              modelValue: selectedTemplateId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTemplateId).value = $event)),
              "saved-template": _ctx.savedTemplate,
              templates: _unref(approvalFlowStore).templates,
              "is-deleting": isDeletingTemplate.value,
              onDelete: openDeleteConfirm
            }, null, 8, ["modelValue", "saved-template", "templates", "is-deleting"])
          ]),
          scales: _withCtx(() => [
            _createVNode(UnitsAndScalesTab, {
              modelValue: selectedScaleId.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedScaleId).value = $event)),
              "grouped-data": _unref(approvalFlowStore).groupedTemplates
            }, null, 8, ["modelValue", "grouped-data"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modal-active"]),
    _createVNode(ConfirmDeleteRoleModal, {
      modelValue: showDeleteConfirm.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showDeleteConfirm).value = $event)),
      title: "Excluir modelo",
      description: "Tem certeza que deseja excluir esse modelo de validação de excepcionalidade? Essa ação não poderá ser revertida",
      loading: isDeletingTemplate.value,
      onConfirm: handleConfirmDelete
    }, null, 8, ["modelValue", "loading"]),
    _createVNode(ModalVue, {
      "modal-active": showSuccessModal.value,
      "max-width": "!max-w-[480px]",
      "show-close-button": false,
      "has-header-border": "",
      onClose: closeSuccessModal
    }, {
      header: _withCtx(() => [
        _hoisted_5
      ]),
      footer: _withCtx(() => [
        _createVNode(FilledButton, {
          text: "Fechar",
          width: "100%",
          class: "bg-primary30",
          onClick: closeSuccessModal
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SuccessIcon, {
            width: "64",
            height: "64",
            color: "#2E7D32"
          }),
          _hoisted_7
        ])
      ]),
      _: 1
    }, 8, ["modal-active"])
  ]))
}
}

})